import React from "react";
import "./Hero.css";
//import logo from "../assets/logo.png";
import GridMotion from "./GridMotion";
import CircularText from "./CircularText"; // ⬅️ IMPORTANTE

import uno from "../assets/back/uno.jpg";
import dos from "../assets/back/dos.jpg";
import tres from "../assets/back/tres.jpg";
import cuatro from "../assets/back/cuatro.jpg";
import cinco from "../assets/back/cinco.jpg";
import seis from "../assets/back/seis.jpg";
import siete from "../assets/back/siete.jpg";
import ocho from "../assets/back/ocho.jpg";
import nueve from "../assets/back/nueve.jpg";
import diez from "../assets/back/diez.png";
import once from "../assets/back/once.jpg";


import logoVideo from "../assets/gl.mp4";

function Hero() {

  const gridImages = [
    uno, dos, tres, cuatro, cinco, seis, siete, ocho, nueve, diez, once,
    uno, dos, tres, cuatro, cinco, seis, dos, tres, cuatro, cinco, seis,
    siete, ocho, nueve, diez, once
  ];

  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <GridMotion gradientColor="#a8a8a8ff" items={gridImages} />
      </div>

      <div className="hero-content">

        <div className="logo-wrapper">
          <CircularText
            text="GLACK STUDIOS • GLACK STUDIOS • "
            spinDuration={25}
          />

        
          <video
            src={logoVideo}
            className="hero-logo"
            autoPlay
            loop
            muted
            playsInline
            webkit-playsinline="true"
          />

        
        </div>

        <h1>Bienvenido</h1>
        <p></p>
        <a href="#cover-art" className="hero-btn">Portafolio</a>
        <p></p>
        <p>Artista Visual</p>
      </div>
    </section>
  );
}

export default Hero;
